package gr.tech.GRAttestation.components.widgets

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.PageContext
import com.varabyte.kobweb.silk.components.navigation.Link
import gr.tech.GRAttestation.util.Constants.FONT_FAMILY
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Nav
import org.jetbrains.compose.web.dom.Ol
import org.jetbrains.compose.web.dom.Text

@Composable
fun NavBreadcrumb(
    ctx: PageContext
) {
    val segments = ctx.route.path
        .trim('/')
        .split('/')
        .filter { it.isNotBlank() }

    if (segments.isEmpty()) return

    val links = segments.runningFold("") { acc, next ->
        if (acc.endsWith("/")) "$acc$next" else "$acc/$next"
    }.drop(1)

    val crumbs = segments.zip(links)

    Nav(attrs = Modifier.classNames("breadcrumb-container").toAttrs()
    ) {
        Ol(attrs = Modifier.classNames("breadcrumb").toAttrs()) {
            crumbs.forEachIndexed { index, (label, link) ->
                val isLast = index == crumbs.lastIndex
                Li(
                    attrs = Modifier
                        .classNames("breadcrumb-item")
                        .thenIf(
                            condition = isLast,
                            other = Modifier.classNames("active")
                        )
                        .toAttrs {}
                ) {
                    if (isLast) {
                        Text(label.replaceFirstChar { it.uppercaseChar() })
                    } else {
                        Link(
                            path = link,
                            modifier = Modifier.classNames("text-primary")
                                .fontFamily(FONT_FAMILY).fontSize(1.cssRem).textDecorationLine(TextDecorationLine.Underline)
                        ) {
                            Text(label.replaceFirstChar { it.uppercaseChar() })
                        }
                    }
                }
            }
        }
    }
}